import React from 'react';
import { Box, Card, CardHeader, CardContent, Stack } from '@mui/material';

import Scrollbar from '../../../../../components/Scrollbar';
import { PaymentDateRangeForm } from './PaymentDateRangeForm';

export const FullScreenView = props => {
  const { data, submitCallback, handleClose, allChoices } = props;

  return (
    <Scrollbar>
      <Box display="flex" flexDirection="row" justifyContent="space-between" mt={1} mr={2}>
        <Stack flex="1 1 70%">
          <Card>
            <CardHeader title={data ? 'Edytuj przedział płatności' : 'Dodaj przedział płatności'} sx={{ mt: -1, mb: -2 }} />
            <CardContent>
              <PaymentDateRangeForm
                data={data}
                submitCallback={submitCallback}
                handleClose={handleClose}
                allChoices={allChoices} />
            </CardContent>
          </Card>
        </Stack>
      </Box>
    </Scrollbar>
  );
};
